import { useEffect } from "react";

const IMJOVE_LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_ecosystem-labs-2/artifacts/eh1156bh_1950C3CC-6226-4B87-972F-379D46DEEC26.png";

// React 19 hoists title/meta/script tags rendered anywhere. This component
// updates document head for SEO + structured data.
export default function SEO({ title, description, image, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    const ogImage = image || IMJOVE_LOGO;
    const setMeta = (attr, key, val) => {
      if (!val) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:site_name", "ImJove Tech");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    let ld;
    if (jsonLd) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.text = JSON.stringify(jsonLd);
      document.head.appendChild(ld);
    }
    return () => {
      if (ld) document.head.removeChild(ld);
    };
  }, [title, description, image, jsonLd]);

  return null;
}
